module.exports = __webpack_public_path__ + "media/images/hero/home-hero-right-6d306ca3a81c5272a1caa323ef899338.svg";